var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        ref: "form",
        attrs: { "data-vv-scope": "form" },
        on: { submit: _vm.attemptRecover }
      },
      [
        _c("vs-input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            }
          ],
          staticClass: "w-full",
          attrs: {
            name: "correo",
            "icon-no-border": "",
            icon: "icon icon-user",
            "icon-pack": "feather",
            "label-placeholder": "Correo electrónico",
            danger: _vm.errors.has("form.correo"),
            "danger-text": _vm.errors.first("form.correo")
          },
          model: {
            value: _vm.correo,
            callback: function($$v) {
              _vm.correo = $$v
            },
            expression: "correo"
          }
        }),
        _c(
          "div",
          {
            staticClass: "d-flex justify-content-between align-items-start mt-5"
          },
          [
            _c(
              "b-button",
              {
                staticClass: "close-button mr-4",
                attrs: { variant: "flat-secondary" },
                on: { click: _vm.closeForm }
              },
              [_vm._v(" Ya recordé, mejor no ")]
            ),
            _c(
              "vs-button",
              {
                staticClass: "btn-ingresar mb-10",
                on: {
                  click: function($event) {
                    return _vm.attemptRecover()
                  }
                }
              },
              [_vm._v(" Enviar ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }